<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Proveedores</h5>
          <div class="row mb-3">
            <div class="col-md-8">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.search"
                    class="form-control"
                    placeholder="Buscar por nombre, razón social o NIT..."
                    @keyup.enter="handleSearch"
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('param_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nuevo Proveedor
              </BButton>
              <BButton
                v-if="hasPermission('param_create')"
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Razón Social</th>
                    <th>NIT</th>
                    <th>Contacto</th>
                    <th>Teléfono</th>
                    <th>Dirección</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="proveedor in proveedores" :key="proveedor.id">
                    <td>{{ proveedor.razon_social }}</td>
                    <td>{{ proveedor.nit }}</td>
                    <td>{{ proveedor.nombre_contacto }}</td>
                    <td>{{ proveedor.telefono }}</td>
                    <td>{{ proveedor.direccion }}</td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          v-if="hasPermission('param_update')"
                          @click="showModal(proveedor)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('param_delete')"
                          @click="confirmDelete(proveedor)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Nombre del Contacto</label>
              <input
                type="text"
                v-model="form.nombre_contacto"
                class="form-control"
                :class="{ 'is-invalid': errors.nombre_contacto }"
                required
              />
              <div class="invalid-feedback" v-if="errors.nombre_contacto">
                {{ errors.nombre_contacto[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Razón Social</label>
              <input
                type="text"
                v-model="form.razon_social"
                class="form-control"
                :class="{ 'is-invalid': errors.razon_social }"
                required
              />
              <div class="invalid-feedback" v-if="errors.razon_social">
                {{ errors.razon_social[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">NIT</label>
              <input
                type="text"
                v-model="form.nit"
                class="form-control"
                :class="{ 'is-invalid': errors.nit }"
                required
              />
              <div class="invalid-feedback" v-if="errors.nit">
                {{ errors.nit[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Teléfono</label>
              <input
                type="text"
                v-model="form.telefono"
                class="form-control"
                :class="{ 'is-invalid': errors.telefono }"
              />
              <div class="invalid-feedback" v-if="errors.telefono">
                {{ errors.telefono[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Dirección</label>
              <input
                type="text"
                v-model="form.direccion"
                class="form-control"
                :class="{ 'is-invalid': errors.direccion }"
              />
              <div class="invalid-feedback" v-if="errors.direccion">
                {{ errors.direccion[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BPagination } from 'bootstrap-vue-3';

interface Proveedor {
  id: number;
  nombre_contacto: string;
  razon_social: string;
  nit: string;
  direccion: string;
  telefono: string;
  fecha_registro: string;
  usuario_registro: string;
  fecha_edicion: string | null;
  usuario_edicion: string | null;
}

interface Filters {
  search: string;
}

interface FormData {
  id: number | null;
  nombre_contacto: string;
  razon_social: string;
  nit: string;
  direccion: string;
  telefono: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BPagination
  },
  setup() {
    const proveedores = ref<Proveedor[]>([]);
    const loading = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      search: ''
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const form = ref<FormData>({
      id: null,
      nombre_contacto: '',
      razon_social: '',
      nit: '',
      direccion: '',
      telefono: ''
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Proveedor' : 'Nuevo Proveedor';
    });

    const showModal = (proveedor: Proveedor | null) => {
      errors.value = {};
      if (proveedor) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: proveedor.id,
          nombre_contacto: proveedor.nombre_contacto,
          razon_social: proveedor.razon_social,
          nit: proveedor.nit,
          direccion: proveedor.direccion || '',
          telefono: proveedor.telefono || ''
        };
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          nombre_contacto: '',
          razon_social: '',
          nit: '',
          direccion: '',
          telefono: ''
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/proveedor/${form.value.id}/update`, form.value);
        } else {
          response = await axios.post('/proveedor/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: isEditing.value ? 'Proveedor actualizado correctamente' : 'Proveedor creado correctamente'
        });
        
        modalVisible.value = false;
        fetchProveedores();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchProveedores = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.search) {
          params.search = filters.value.search;
        }
        
        const response = await axios.get('/proveedor/list', { params });
        proveedores.value = response.data.proveedores.data;
        
        // Actualizar paginación
        pagination.value = {
          current_page: response.data.proveedores.current_page,
          per_page: response.data.proveedores.per_page,
          total: response.data.proveedores.total,
          last_page: response.data.proveedores.last_page
        };
        
      } catch (error) {
        console.error('Error al cargar proveedores:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los proveedores'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchProveedores();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchProveedores();
    };
    
    const confirmDelete = (proveedor: Proveedor) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar el proveedor ${proveedor.razon_social}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteProveedor(proveedor.id);
        }
      });
    };
    
    const deleteProveedor = async (id: number) => {
      try {
        await axios.get(`/proveedor/${id}/delete`);
        Swal.fire({
          icon: 'success',
          title: 'Proveedor eliminado',
          text: 'El proveedor ha sido eliminado correctamente'
        });
        await fetchProveedores();
      } catch (error: any) {
        console.error('Error al eliminar proveedor:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar el proveedor'
        });
      }
    };

    const generatePDF = () => {
      const params = filters.value.search ? { search: filters.value.search } : {};
      
      axios.get('/proveedor/reporte', {
        params,
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte_proveedores.pdf`);
        document.body.appendChild(link);
        link.click();
        
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchProveedores();
    });
    
    return {
      proveedores,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
</style>